import { combineReducers, type Reducer, type ReducersMapObject } from '@reduxjs/toolkit'

export interface ReducerManager<State extends object> {
  reduce: Reducer<State>
  add<Key extends string>(key: Key, reducer: Reducer): void
  has(key: string): boolean
}

export function createReducerManager<State extends object>(initialReducers: ReducersMapObject): ReducerManager<State> {
  const reducers = { ...initialReducers }
  let combinedReducer = combineReducers(reducers)

  return {
    reduce: (state, action) => combinedReducer(state, action) as State,
    add(key, reducer) {
      if (reducers[key]) return
      reducers[key] = reducer
      combinedReducer = combineReducers(reducers)
    },
    has(key) { return Boolean(reducers[key]) },
  }
}
